<template>
  <div>
    <div>
      <p>{{ payload.content }}</p>
      <div class="is-flex is-align-items-center">
        <p><b>Applicant:</b></p>
        <div class="horizontal_space"></div>
        <link-entity :payload="payload.resources.applicant"></link-entity>
      </div>
      <div class="is-flex is-align-items-center">
        <ghana-flag :payload="payload.resources.applicant"></ghana-flag>
        <div class="horizontal_space"></div>
        <WhatsAppLink :phoneNumber="payload.resources.applicant.phone_number" :message="textWhatsApp"></WhatsAppLink>
      </div>

      <!-- הוראות פולואופ -->
      <div class="instructions-box">
        <h4 class="instructions-title">📋 הוראות פולואופ מועמדים</h4>
        <ul class="instructions-list">
          <li>יש להתקשר למועמד ולבדוק האם יצרו איתו קשר ממשרה זו או ממשרות אחרות</li>
          <li>אם המועמד רלוונטי וטרם יצרו איתו קשר - לשלוח אותו שוב למשרה או להקפיץ מועמדות במייל.</li>
          <li>אם מועמד מצוין - יש להתקשר טלפונית למעסיק לגביו.</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import GhanaFlag from '@/components/GhanaFlag'
import WhatsAppLink from '@/components/WhatsAppLink'
import LinkEntity from '@/components/LinkEntity'
export default {
  name: 'alert-content-send-cv',
  props: ['payload'],
  computed: {
    textWhatsApp () {
      return `היי ${this.payload.resources.applicant.first_name}, האם חזרו אליך מאחת החברות ששלחנו אותך?`
    }
  },
  components: {
    GhanaFlag,
    WhatsAppLink,
    LinkEntity
  }
}
</script>

<style scoped>
.instructions-box {
  margin-top: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-right: 4px solid #2196f3;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  direction: rtl;
  text-align: right;
}

.instructions-title {
  margin: 0 0 12px 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1565c0;
  text-align: right;
}

.instructions-list {
  margin: 0;
  padding-right: 20px;
  list-style-position: inside;
  text-align: right;
}

.instructions-list li {
  margin-bottom: 10px;
  line-height: 1.6;
  color: #1976d2;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: right;
}

.instructions-list li:last-child {
  margin-bottom: 0;
}
</style>
